import { Service } from '../Service';
export default class GroupService extends Service {
    constructor(axios) {
        super(axios);
    }
}
